exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sync-xero{position:absolute;right:30px;bottom:50px;z-index:100}", ""]);

// exports
